<template>
  <!-- 人工批改详情：展示 AI 建议评分。
       接口未返回 aiScores（题型不支持 AI 评分 / 尚未生成）时不占位、不展示 -->
  <div class="ai-suggest-score" v-if="hasScore">
    {{ $t('mark_ai_suggest_score') }}: {{ score }}
  </div>
</template>

<script>
export default {
  name: 'AiSuggestScore',
  props: {
    // 来自 v1/examination/listAnswer 的 aiScores 字段
    score: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    hasScore() {
      return this.score !== null && this.score !== undefined && this.score !== ''
    },
  },
}
</script>

<style lang="scss" scoped>
.ai-suggest-score {
  margin-top: 12px;
  text-align: right;
  color: #faae56;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
}
</style>
